import React from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import Modal from '~components/atoms/Modal';
import FormCreateCustomerTransferModal from '../FormCreateCustomerTransferModal';
import CustomerTransferSummary from '../CustomerTransferSummary';

const CreateCustomerTransferModal = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(state => state.customerTransfer.modals.createCustomerTransferModalIsOpen);
    const isFormFilled = useAppSelector((state) => state.customerTransfer.modals.isFormFilled);

    const handleModalOnClose = () => {
        dispatch(combinedActions.customerTransferResetCreateNewCustomerTransferState());
        dispatch(combinedActions.customerTransferSetIsFormFilled(false));
        dispatch(combinedActions.customerTransferSetCreateCustomerTransferModalIsOpen(false));
    };

    return (
        <Modal
            title='Create Customer Transfer'
            isOpen={isOpen}
            onClose={handleModalOnClose}
        >
            <div style={{ display: isFormFilled ? 'none' : 'block' }}>
                <FormCreateCustomerTransferModal
                    submitButtonLabel='Create Customer Transfer'
                />
            </div>

            {isFormFilled && <CustomerTransferSummary />}
        </Modal>
    );
};

export default CreateCustomerTransferModal;
